<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import RouteTransition from '../RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';
  import Paths from '../Utils/Paths.svelte';

  import {
    idTrappe,
    type,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    couleur,
  } from '../stores.js';

  import ChoixTrappe from '../Pages/ChoixTrappe.svelte';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  import BtnPageVideSanitaire from '../ComponentsInProcess/BtnPageVideSanitaire.svelte';
  import RangeSliderVideSanitaire from '../ComponentsInProcess/range-slider-3-vide-sanitaire.svelte';
  import SideBarNew from '../ComponentsInProcess/SideBar-new.svelte';
  export let idFiche;

  // console.log(`$idTrappe - Sanitaire : ${$idTrappe}`);
  // console.log(`idFiche - Sanitaire : ${idFiche}`);
</script>

<Paths />

{#if idFiche == 1}
  <div in:fly="{{ x: 100, duration: 800 }}">
    <RangeSliderVideSanitaire
      idFiche="{idFiche}"
      titre="{'Longueur'}"
      soustitre="{'avec une l'}"
    />
  </div>
{:else if idFiche == 2}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageVideSanitaire
        idFiche="{idFiche}"
        idBtn="2"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageVideSanitaire
        idFiche="{idFiche}"
        idBtn="3"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{:else if idFiche == 3}
  <Paths />
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageVideSanitaire
        idBtn="4"
        idFiche="{idFiche}"
        titre="{'Clé carrée'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}
